<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #contactSupport>
      <button class="inline-btn-link" target="_blank" @click="goToSupportPage()">
        {{ t("NotificationsComponent.contactSupport") }}
      </button>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";
import { getUrl } from "@/common/getUrl";

const componentName = "EmailAlreadyInUseNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  setup() {
    function goToSupportPage() {
      window.open(getUrl("VITE_APP_CARBONITE_SUPPORT_SITE"), "_blank");
    }

    return { t, goToSupportPage };
  },
});
</script>
